import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../service/auth-service';

export const permissionGuard: CanActivateFn = (route, state) => {
  const platformId = inject(PLATFORM_ID);
  
  // During SSR or route extraction, always allow access to prevent build issues
  if (!isPlatformBrowser(platformId)) {
    return true;
  }
  
  const authService = inject(AuthService);
  const router = inject(Router);
  
  // Extract and validate the required permissions from route data
  const requiredPermissions: number[] = route.data['permissions'];
  if (!requiredPermissions?.length) {
    return router.parseUrl('/unauthorized'); // Redirect immediately if no permissions are required
  }

  // Check if the user has the required permissions
  if (authService.canAccess(requiredPermissions)) {
    return true;
  }

  return router.parseUrl('/unauthorized'); // Redirect if access is denied
};